import styled from 'styled-components';

const Page = styled.main`
  max-width: 1040px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
`;

const Title = styled.h1`
  color: #7a1f2b;
  margin-bottom: 1.5rem;
  font-size: clamp(2rem, 4vw, 2.8rem);
`;

const Card = styled.section`
  background: #fff;
  border-radius: 18px;
  padding: 2rem;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0e7dc;

  @media (max-width: 640px) {
    padding: 1.4rem;
  }
`;

const Section = styled.div`
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  color: #7a1f2b;
  font-size: 1.15rem;
  margin-bottom: 0.8rem;
`;

const Text = styled.p`
  margin: 0 0 0.45rem;
  line-height: 1.7;
  color: #2f2a26;
`;

const DataGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(170px, 260px) 1fr;
  gap: 0.65rem 1rem;
  margin-top: 0.6rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }
`;

const Label = styled.div`
  font-weight: 700;
  color: #5f5044;
`;

const Value = styled.div`
  color: #2f2a26;
  line-height: 1.6;
`;

const LinkText = styled.a`
  color: #7a1f2b;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const InfoBox = styled.div`
  background: #fff8ed;
  border: 1px solid #eadbc5;
  border-radius: 14px;
  padding: 1rem;
  color: #5f5044;
  line-height: 1.65;
`;

function ImpressumPage() {
  return (
    <Page>
      <Title>Impressum</Title>

      <Card>
        <Section>
          <SectionTitle>Medieninhaberin, Herausgeberin und Betreiberin</SectionTitle>
          <Text>
            <strong>Petra Michaela Kausch</strong>
          </Text>
          <Text>Stadtheuriger zum Brückl</Text>
          <Text>Wienerstraße 26</Text>
          <Text>2620 Neunkirchen</Text>
          <Text>Österreich</Text>
        </Section>

        <Section>
          <SectionTitle>Kontakt</SectionTitle>
          <DataGrid>
            <Label>Telefon</Label>
            <Value>
              <LinkText href="tel:+436703504707">0670 / 3504707</LinkText>
            </Value>

            <Label>E-Mail</Label>
            <Value>
              <LinkText href="mailto:office@stadtheuriger-neunkirchen.at">
                office@stadtheuriger-neunkirchen.at
              </LinkText>
            </Value>
          </DataGrid>
        </Section>

        <Section>
          <SectionTitle>Unternehmensdaten</SectionTitle>
          <DataGrid>
            <Label>Firmenname</Label>
            <Value>Petra Michaela Kausch</Value>

            <Label>GLN</Label>
            <Value>9110027353759</Value>

            <Label>GISA-Zahl</Label>
            <Value>3937097</Value>

            <Label>Gewerbe</Label>
            <Value>Gastgewerbe in der Betriebsart Gasthaus</Value>

            <Label>Fachgruppe</Label>
            <Value>FG Gastronomie</Value>

            <Label>Zuständige Kammer</Label>
            <Value>Wirtschaftskammer Österreich / Wirtschaftskammer Niederösterreich</Value>

            <Label>Zuständige Aufsichtsbehörde / Gewerbebehörde</Label>
            <Value>Bezirkshauptmannschaft Neunkirchen</Value>

            <Label>Anwendbare Rechtsvorschriften</Label>
            <Value>
              Gewerbeordnung 1994, abrufbar unter{' '}
              <LinkText
                href="https://www.ris.bka.gv.at"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.ris.bka.gv.at
              </LinkText>
            </Value>
          </DataGrid>
        </Section>

        <Section>
          <SectionTitle>Unternehmensgegenstand</SectionTitle>
          <Text>
            Betrieb eines Heurigenlokals sowie Bewirtung von Gästen mit Speisen und Getränken.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Grundlegende Richtung der Website</SectionTitle>
          <Text>
            Diese Website dient der Information über den Stadtheurigen zum Brückl,
            das gastronomische Angebot, die Speisekarte, Öffnungszeiten,
            Kontaktmöglichkeiten und Reservierungsanfragen.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Verantwortlich für den Inhalt</SectionTitle>
          <Text>
            Für die Inhalte dieser Website, insbesondere Texte, Speisekarte,
            Preise, Öffnungszeiten, Kontaktdaten, Bilder und sonstige bereitgestellte
            Informationen, ist die Medieninhaberin und Betreiberin Petra Michaela
            Kausch verantwortlich.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Bildmaterial und Urheberrechte</SectionTitle>
          <Text>
            Die auf dieser Website verwendeten Bilder und Inhalte wurden von der
            Betreiberin bereitgestellt oder zur Verwendung auf dieser Website
            freigegeben. Die Verantwortung für die Berechtigung zur Nutzung des
            bereitgestellten Bild- und Inhaltsmaterials liegt bei der Betreiberin.
          </Text>
          <Text>
            Texte, Bilder, grafische Elemente und sonstige Inhalte dieser Website
            dürfen ohne vorherige Zustimmung der jeweiligen Rechteinhaber nicht
            vervielfältigt, bearbeitet, verbreitet oder anderweitig verwendet werden,
            sofern keine gesetzliche Erlaubnis besteht.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Konzeption, Webdesign und technische Umsetzung</SectionTitle>
          <DataGrid>
            <Label>Umsetzung</Label>
            <Value>
              <strong>Software Solution</strong>
            </Value>

            <Label>Ansprechpartner</Label>
            <Value>Ralph-Peter Zillbauer</Value>

            <Label>Website</Label>
            <Value>
              <LinkText
                href="https://softwaresolution.at"
                target="_blank"
                rel="noopener noreferrer"
              >
                softwaresolution.at
              </LinkText>
            </Value>
          </DataGrid>

          <InfoBox>
            Die technische Umsetzung dieser Website erfolgte im Auftrag der
            Betreiberin. Software Solution ist nicht Medieninhaber, nicht Betreiber
            und nicht inhaltlich Verantwortlicher dieser Website. Die Verantwortung
            für Inhalte, Bilder, Preise, Speisekarte, Öffnungszeiten und rechtliche
            Angaben liegt bei der Betreiberin.
          </InfoBox>
        </Section>

        <Section>
          <SectionTitle>Haftung für Inhalte</SectionTitle>
          <Text>
            Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt.
            Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte wird
            jedoch keine Gewähr übernommen. Änderungen, Irrtümer und kurzfristige
            Anpassungen, insbesondere bei Speisekarte, Preisen, Öffnungszeiten und
            Verfügbarkeiten, bleiben vorbehalten.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Haftung für externe Links</SectionTitle>
          <Text>
            Diese Website kann Links zu externen Websites enthalten. Auf die Inhalte
            externer Websites besteht kein Einfluss. Für fremde Inhalte wird daher
            keine Haftung übernommen. Für den Inhalt verlinkter Seiten sind
            ausschließlich deren Betreiber verantwortlich.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Datenschutz</SectionTitle>
          <Text>
            Informationen zur Verarbeitung personenbezogener Daten finden Sie in
            unserer Datenschutzerklärung.
          </Text>
        </Section>
      </Card>
    </Page>
  );
}

export default ImpressumPage;